<template>
  <div class="sidebar-panel">
    <div class="logo" @click="goHome">
      <img :src="logo" width="36" />
      <span v-if="!collapsed">道路裂纹检测</span>
    </div>
    <a-menu
      theme="light"
      mode="inline"
      :selectedKeys="selectedKeys"
      :openKeys="openKeys"
      :inline-collapsed="collapsed"
      :style="{width: collapsed ? '80px' : '256px'}"
      @click="switchView"
      @openChange="openChange"
    >
      <a-menu-item key="/page/home" >
        <a-icon type="home" /><span>首页</span>
      </a-menu-item>

      <a-sub-menu v-for="menu in menus" :key="menu.key">
        <span slot="title">
          <a-icon :type="menu.icon" /><span>{{menu.name}}</span></span>
        <a-menu-item v-for="submenu of menu.submenus" :key="submenu.key">{{submenu.name}}</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/page/ad" >
        <a-icon type="home" /><span>公告</span>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import menus from '@/menus.js'

export default {
  name: 'Sidebar',
  props: ['collapsed'],
  data() {
    return {
      menus,
      openKeys: [],
      selectedKeys: [],
      logo: require('@/assets/logo.png')
    };
  },
  methods: {
    initialize() {
      this.changeRoute(this.$route.path);
    },
    goHome() {
      if (this.$route.path !== '/page/home') {
        this.$router.push('/page/home');
      }
      this.$emit('navigate');
    },
    switchView(item) {
      if (this.$route.path !== item.key) {
        this.$router.push(item.key);
      }
      this.$emit('navigate');
    },
    openChange(openKeys) {
      this.openKeys = [openKeys[openKeys.length - 1]];
    },
    changeRoute(path) {
      this.selectedKeys = [path];
      for (let m of menus) {
        if (m.submenus.findIndex(item => item.key == path) != -1) {
          this.openKeys = [m.key];
          return
        }
      }
    },
  },
  watch: {
    $route(to) {
      this.changeRoute(to.path);
    },
  },
  created() {
    this.initialize();
  },
}
</script>

<style scoped>
.sidebar-panel {
  height: 100vh;
  overflow-y: auto;
}

.logo {
  width: 256px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-weight: bold;
  font-size: 20px;
  height: 64px;
  padding: 16px;
  border-bottom: 1px solid #6662;
  cursor: pointer;
}

.logo img {
  margin-top: -6px;
  margin-left: 8px;
}

.logo span {
  color: #1890ff;
  font-size: 16px;
}
</style>
